import React, { useState, useEffect, useCallback } from "react";
import { fetchAgents, fetchHealth } from "./api";
import FilterBar from "./components/FilterBar";
import AgentList from "./components/AgentList";
import "./App.css";

function App() {
  const [agents, setAgents] = useState([]);
  const [health, setHealth] = useState(null);
  const [status, setStatus] = useState("all");
  const [tag, setTag] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadAgents = useCallback(async () => {
    try {
      setLoading(true);
      const data = await fetchAgents({ status, tag: tag.trim() || undefined });
      setAgents(data);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [status, tag]);

  const loadHealth = useCallback(async () => {
    try {
      const data = await fetchHealth();
      setHealth(data);
    } catch (_) {}
  }, []);

  useEffect(() => {
    loadAgents();
    loadHealth();
  }, [loadAgents, loadHealth]);

  useEffect(() => {
    const interval = setInterval(() => {
      loadAgents();
      loadHealth();
    }, 15000);
    return () => clearInterval(interval);
  }, [loadAgents, loadHealth]);

  return (
    <div className="app">
      <header className="app-header">
        <h1>Hive Registry</h1>
        <div className="header-status">
          {health && (
            <span className="health-indicator">
              <span className="health-dot" />
              {health.agents_registered} agent{health.agents_registered !== 1 ? "s" : ""} registered
            </span>
          )}
        </div>
      </header>

      <main className="app-main">
        <FilterBar
          status={status}
          onStatusChange={setStatus}
          tag={tag}
          onTagChange={setTag}
        />

        {error && <div className="error-banner">{error}</div>}

        {loading && agents.length === 0 ? (
          <p className="loading">Loading agents...</p>
        ) : (
          <AgentList agents={agents} />
        )}
      </main>
    </div>
  );
}

export default App;
